module.exports = __webpack_public_path__ + "static/media/visa-ic.74f58fd9.svg";